module.exports = __webpack_public_path__ + "img/check.8ba94e32.png";